import fire from '../../images/icons/fire.svg';
import paging from '../../images/icons/paging.svg';
import audio from '../../images/icons/audio.svg';
import telephony from '../../images/icons/telephony.svg';
import voice from '../../images/icons/voice.svg';
import access from '../../images/icons/access.svg';
import security from '../../images/icons/security.svg';
import serviceFireTop from '../../images/services/service_fire_top.png';
// import serviceFireBottom from '../../images/services/service_fire_bottom.png';
import servicePagingTop from '../../images/services/service_paging_top.png';
// import servicePagingBottom from '../../images/services/service_paging_bottom.png';
import serviceAudioTop from '../../images/services/service_audio_top.png';
import serviceAudioBottom from '../../images/services/service_audio_bottom.png';
import serviceTelephonyTop from '../../images/services/service_telephony_top.png';
// import serviceTelephonyBottom from '../../images/services/service_telephony_bottom.png';
import serviceVoiceTop from '../../images/services/service_voice_top.png';
// import serviceVoiceBottom from '../../images/services/service_voice_bottom.png';
import serviceAccessTop from '../../images/services/service_access_top.png';
// import serviceAccessBottom from '../../images/services/service_access_bottom.png';
import serviceSecurityTop from '../../images/services/service_security_top.png';
// import serviceSecurityBottom from '../../images/services/service_security_bottom.png';

const ServicePages = {
  'fire-alarms-safety': {
    slug: 'fire-alarms-safety',
    bgImage:
      'bg-center bg-service-fire-375 md:bg-service-fire-768 lg:bg-service-fire-1024 2xl:bg-service-fire-1536 3xl:bg-service-fire-1920',
    bgColor: 'bg-techsicoRed-500',
    icon: fire,
    title: 'Fire Alarms & Life Safety',
    content: `Fire alarms and life safety systems are a critical component in keeping your employees safe.
        
        Techsico has multiple proprietary brands of fire alarm systems and can service and inspect most systems. Building code requires an annual inspection for fire alarm systems and we have some of the lowest rates for service and inspections around. 
        
        Techsico also installs many life safety systems including mass notifcation systems, nurse call systems, area of refuge, and many more. 
        
        Techsico can solve all of your fire alarm and life safety needs.`,
    topImage: serviceFireTop,
    // bottomImage: serviceFireBottom,
  },
  'paging-intercom-clocks': {
    slug: 'paging-intercom-clocks',
    bgImage:
      'bg-center bg-cover bg-service-paging-375 md:bg-service-paging-768 lg:bg-service-paging-1024 2xl:bg-service-paging-1536 3xl:bg-service-paging-1920',
    bgColor: 'bg-techEnter-500',
    icon: paging,
    title: 'Paging, Intercom, & Clocks',
    content: `Techsico can design, install, and service your paging, intercom system, including Bogen, Carehawk, Valcom, Sapling, Primex, and American Time & Signaling to bring you only the best in paging, intercom, and clock systems. 
        
        We can install a paging system with any number of zones enabling you to get your message or altert to the right person or campus-wide with ease.
        
        We can integrate your bell schedules and prerecorded announcements allowing you to create audible indications of shift changes or alert emergencies over your paging system. 
        
        We can offer a wide range of custom integrations, including allowing paging in another office on the other side of the globe or to a phone in the office next to you. 
        
        We can also design and install intercom systems enabling two-way communication utilizing the speaker as both a microphone and speaker. 
        
        We can integrate with your clock system to allow bell and announcement schedule that is always in sync with the clock system in all of your buildings. Based on your needs, we can install traditional clock systems utilizing a master clock on-site or IP-clocks that sync their time with an internet based time server`,
    topImage: servicePagingTop,
    // bottomImage: servicePagingBottom,
  },
  'audio-video': {
    slug: 'audio-video',
    bgImage:
      'bg-center bg-cover bg-service-audio-375 md:bg-service-audio-768 lg:bg-service-audio-1024 2xl:bg-service-audio-1536 3xl:bg-service-audio-1920',
    bgColor: 'bg-gray-500',
    icon: audio,
    title: 'Audio/Video',
    content: `Audio and video systems continue to evolve. Techsico has the lines and training to keep up with this quickly changing market. The workplace has moved to a more technological environment and systems such as video conferencing and digital signage are no longer an add on, but a central part of the workplace. Houses of workship are incorporating more lighting and pro audio video into their services. 
        
        Techsico is certified and trained in top of the line systems that can achieve the environment you need. Techsico is a proud certified Creston installer.`,
    topImage: serviceAudioTop,
    bottomImage: serviceAudioBottom,
  },
  'telephony-network': {
    slug: 'telephony-network',
    bgImage:
      'bg-center bg-cover bg-service-telephony-375 md:bg-service-telephony-768 lg:bg-service-telephony-1024 2xl:bg-service-telephony-1536 3xl:bg-service-telephony-1920',
    bgColor: 'bg-techsicoBlue-800',
    icon: telephony,
    title: 'Telephony & Network Engineering',
    content: `Techsico's extensive knowledge of telephony and networking solutions allows us to provide your company with the best design, service, and installation experience. 
        
        Our networking partners, such as Meraki, Cisco, Zyxel, Ubiquiti, Aruba, and Cambium Networks, ensure you will get the best in wired and wireless networking solutions. We have also partnered with telephony providers such as Mitel, Shoretel, NEC, and Avaya, allowing us to provide the best telephony solutions for your business. 
        
        We offer a full range of solutions, whether your are looking for state of the art IP phone system or a traditional digital phone system, Techsico is here to help. 
        
        Techsico provides service and support on most other manufacturers' phone systems. Our expert network engineers allow us to design and setup your network the way your company needs it, such as PCs, IP cameras, IP telephones, IP access control devices, IP paging devices"`,
    topImage: serviceTelephonyTop,
    // bottomImage: serviceTelephonyBottom,
  },
  'voice-data': {
    slug: 'voice-data',
    bgImage:
      'bg-center bg-cover bg-service-voice-375 md:bg-service-voice-768 lg:bg-service-voice-1024 2xl:bg-service-voice-1536 3xl:bg-service-voice-1920',
    bgColor: 'bg-techsicoBlue-500',
    icon: voice,
    title: 'Voice & Data',
    content: `With the increasing demands placed on networks, Techsico can ensure you have the bandwidth and flexibility to accommodate all your needs. The demand on networks is increasing at an exponential rate. Video conferencing, streaming video and music, wireless demands all increase the need to have a secure and robust network. 
        
        Techsico is equipped and trained to handle all types of fiber and copper including aerial, outside plant, coax, in building structured cabling, wireless, and any other need you may have.`,
    topImage: serviceVoiceTop,
    // bottomImage: serviceVoiceBottom,
  },
  'access-control': {
    slug: 'access-control',
    bgImage:
      'bg-center bg-cover bg-service-access-375 md:bg-service-access-768 lg:bg-service-access-1024 2xl:bg-service-access-1536 3xl:bg-service-access-1920',
    bgColor: 'bg-wirelessGreen-700 bg-opacity-100',
    icon: access,
    title: 'Access Control',
    content: `Techsico can design, install, and service access control systems for business big or small. 
        
        We have partnered with the top companies in access control such as Avigilon, S2, Bosch, Axis, Kantech, Vingtor/Stentofon, and Aiphone to give our customers the best solution for the physical security of their sites. 
        
        The integration of video and audio intercom systems with acceess control systems can allow you to secure your facility and allow authorized individuals in your facility. Techsico uses electric or magnetic locks in combination with badge readers and/or keypads so you can selectively give employees and guests access to areas or rooms and deny access to other areas or rooms. 
        
        We can integrate your access control system with your camera system and give you the ability to capture videos of anyone accessing or trying to access your facilities.`,
    topImage: serviceAccessTop,
    // bottomImage: serviceAccessBottom,
  },
  'security-surveillance-solutions': {
    slug: 'security-surveillance-solutions',
    bgImage:
      'bg-center bg-service-security-375 md:bg-service-security-768 lg:bg-service-security-1024 2xl:bg-service-security-1536 3xl:bg-service-security-1920',
    bgColor: 'bg-techsicoGray-700 bg-opacity-70',
    icon: security,
    title: 'Security & Surveillance Solutions',
    content: `Techsico can provide multiple services for all of your security needs. CCTV cameras and DVR/NVRs can provide a safer place to work along with reducing theft. 
        
        Access control is an effective way to secure your facility with flexibility not provided by traditional locks. Intrusion detection enables you to have Techsico monitor your system and notify authorities if anyone is in your facility that shouldn't be. 
        
        With innovative product lines, Techsico can even tie all these systems together to make your workplace, school, house of worship, or any other facility safe.`,
    topImage: serviceSecurityTop,
    // bottomImage: serviceSecurityBottom,
  },
};

export default ServicePages;
